export default "/images/e1b9b4a7d4af838d44da94397b1e031a.png";